module.exports = __webpack_public_path__ + "static/media/18.df343335.jpg";